import { useEffect, useState } from "react";
import { timelineData } from "../constants/Home";
import "./Timeline.css";
import { Link } from "react-router-dom";

const Timeline = () => {
  const [imageIndex, setImageIndex] = useState(0);
  const [textIndex, setTextIndex] = useState(0);

  // ===== AUTO – ZDJĘCIA co 3s =====
  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndex((prev) => (prev + 1) % timelineData.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // ===== AUTO – TEKST co 6s =====
  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % timelineData.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  // STRZAŁKI – tylko tekst
  const handleNextText = () => {
    setTextIndex((prev) => (prev + 1) % timelineData.length);
  };

  const handlePrevText = () => {
    setTextIndex((prev) =>
      (prev - 1 + timelineData.length) % timelineData.length
    );
  };

  return (
    <section className="timeline-slider-wrapper">
      <div className="slider-container">
        {/* ================= ZDJĘCIA ================= */}
        <div className="slider">
          <div
            className="slider-track"
            style={{ transform: `translateX(-${imageIndex * 100}%)` }}
          >
            {timelineData.map((item) => (
              <div key={item.id} className="slide">
                <div className="image-frame">
                  <img src={item.image} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ================= TEKST ================= */}
        <div className="slider text-slider">
          <div
            className="slider-track"
            style={{ transform: `translateX(-${textIndex * 100}%)` }}
          >
            {timelineData.map((item) => (
              <div key={item.id} className="slide">
                <div className="text-frame">
                  <h2>{item.title}</h2>

                  <ul className="timeline-description">
                    {item.description.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>

                  <div className="timeline-buttons">
                    <Link to="/about">
                      <button className="btn">POZNAJ MNIE</button>
                    </Link>

                    <Link
                      to="https://www.instagram.com/studio.piekne.wnetrza/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="btn">
                        ODWIEDŹ MÓJ INSTAGRAM
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* STRZAŁKI */}
      <div className="slider-controls fixed">
        <button onClick={handlePrevText}>&larr;</button>
        <button onClick={handleNextText}>&rarr;</button>
      </div>
    </section>
  );
};

export default Timeline;